/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import BaseTextarea from 'shared/ui/components/form-components/BaseTextarea.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import ImagePicker from 'shared/ui/components/form-components/pickers/ImagePicker.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import WizardStep from 'shared/ui/components/WizardStep.vue';
import WorkspaceCategory from 'shared/ui/components/form-components/WorkspaceCategory.vue';
import NavEditor from 'shared/ui/components/editors/NavEditor.vue';

// Utils
import { get, isEmpty, findKey, isEqual } from 'lodash';

const __vue_script__ = {
    name: 'TemplateForm',

    components: {
        BaseInput,
        BaseSelect,
        BaseTextarea,
        HtmlEditor,
        ImagePicker,
        RadioButtons,
        WorkspaceCategory,
        NavEditor,
    },

    extends: WizardStep,

    props: {
        eventId: {
            type: String,
            default: null
        }
    },

    data() {
        const parentTypes = [{
            name: this.$i18n.t('wizards.create_template.form.parent_type_template'),
            value: 'template'
        }, {
            name: this.$i18n.t('wizards.create_template.form.parent_type_workspace'),
            value: 'workspace'
        }];

        const visibilityOptions = [{
            label: this.$i18n.t('wizards.create_template.form.visibility_options.private'),
            value: 'private'
        }, {
            label: this.$i18n.t('wizards.create_template.form.visibility_options.public'),
            value: 'public'
        }];

        return {
            canChangeOrg: true,
            templateCategory: null,
            templateCategories: [],
            editing: false,
            error: null,
            events: null,
            event: null,
            user: this.$services.user.getCurrentUser(),
            navConfig: null,
            images: [],
            lockVisibility: false,
            originalOrder: null,
            organization: null,
            organizations: [],
            parents: [],
            parentTypes,
            serversLocation: [],
            templates: null,
            userCanSetCategory: this.$services.user.hasPermission('templates.set_category'),
            userCanSetOrder: this.$services.user.hasPermission('templates.set_order'),
            visibility: 'private',
            visibilityOptions
        };
    },

    computed: {
        /**
         * @returns {Boolean} whether the app icon is editable or not
         */
        appIconEditable() {
            return !this.form.ownerId || isEmpty(this.form.app_icon);
        },

        /**
         * @returns {Boolean} whether the user is allowed to set an order or not
         */
        canSetOrder() {
            return this.userCanSetOrder && this.visibility === 'global';
        },

        /** @returns {boolean} */
        canInsertMultipleCategories() {
            return this.isCategoryEnabled && get(this.organization, 'workspace_defaults.category_multiselect', false);
        },

        /** @returns {boolean} */
        isCategoryEnabled() {
            return get(this.organization, 'workspace_defaults.enable_category', false);
        },

        /** @returns {boolean} */
        userIsAdminOrSupport() {
            return this.$services.user.matchesRoles(
                { globalRole: 'superadmin' },
                { globalRole: 'spotme_support' }
            );
        },
    },

    watch: {
        params: {
            deep: true,
            handler(newParams, oldParams) {
                if (!isEqual(newParams, oldParams)) {
                    this.init();
                }
            }
        },

        /**
         * This watcher will pick the correct value from the selected
         * category object.
         */
        templateCategory() {
            this.form.template_category = this.templateCategory && this.templateCategory.value;
        },

        /**
         * This watcher is needed to correctly update the `canSetOrder` computed value
         */
        visibility() {
            this.form.visibility = this.visibility;
        },

        /**
         * Due to the nature of watched object in Vue.js, and the async loads
         * we perform, we have to use this watcher in order to set the correct
         * value on the form when loading the component with prefilled data.
         *
         * The problem is that we have an `async created` hook in conjunction
         * with the `form` model that is an object (which Vue.js handles in a
         * particular way).
         *
         * As of Vue.js 2.6.11 the UI digest is not awaiting for the async
         * creation hooks to be completed, leading to discrepancies between the
         * real data and what the user sees in the browser.
         *
         * To prevent this we use plain property that is handled correctly.
         */
        organization() {
            this.form.organization = this.organization;
            this.cleanCategories();
        }
    },

    mounted() {
        this.originalOrder = this.form.template_order;

        // Setup visibility options
        const canChangeGlobalVisibility = this.$services.user.hasPermission('templates.set_global_visibility');

        if (canChangeGlobalVisibility || this.form.visibility === 'global') {
            if (!this.visibilityOptions.find(o => o.value === 'global')) {
                this.visibilityOptions.push({
                    label: this.$i18n.t('wizards.create_template.form.visibility_options.global'),
                    value: 'global'
                });
            }
        }

        this.init();
    },

    methods: {
        async init() {
            console.log('init');
            try {
                // Setup organizations
                this.organizations = this.userIsAdminOrSupport ?
                    await this.$services.org.getAllOrgs() :
                    this.$services.user.getOrgs().filter(org =>
                        this.$services.user.hasPermission('templates.create_new', { org_id: org._id })
                    );

                // This field is present only on already created templates
                if (this.form.ownerId) {
                    this.editing = true;
                }

                if (this.editing && this.params.form.id) {
                    this.event = await this.$services.event.getEvent(this.params.form.id, this.user);
                    this.navConfig = this.params.currentController?.routeOptions?.navEditors['activation'];
                }

                const canChangeGlobalVisibility = this.$services.user.hasPermission('templates.set_global_visibility');
                if (this.editing && this.form.visibility === 'global' && !canChangeGlobalVisibility) {
                    this.lockVisibility = true;
                }

                // Setup administrative options
                if (this.editing && this.userCanSetCategory) {
                    try {
                        const templateCategories = await this.$services.template.getCategories();

                        this.templateCategories = templateCategories.map(c => ({
                            name: this.$utils.locales.localizeLabel(c.name, this.$i18n.locale),
                            value: c.id
                        }));

                    } catch (error) {
                        console.error('[TemplateForm] An error occurred while fetching templates categories');
                        this.userCanSetCategory = false;
                    }
                }

                // Prefill the form with initial data
                await this.prefill();
            } catch (error) {
                console.error('[TemplateForm] An error occurred while initializing the form', error);
                this.$services.crashReporting.captureException(error);
                this.error = 'general.error_occurred';
            }
        },

        /**
         * Sets up initial form values
         */
        async prefill() {
            // - Prefill organization
            if (this.form.ownerId) {
                // In this scenario we're editing an existing template
                let organization = this.organizations.find(o => o._id === this.form.ownerId);

                if (!organization) {
                    const orgName = this.$services.org.getDisplayName(this.params.form.ownerId);
                    console.warn('[TemplateForm] Could not find the template org within users\'s orgs, this could mean the user has no administrative access to "%s"', orgName);

                    organization = {
                        _id: this.params.form.ownerId,
                        name: orgName
                    };

                    this.organizations.unshift(organization);
                    this.canChangeOrg = false;
                }

                this.organization = organization;
            } else if (this.organizations.length === 1) {
                // In this scenario the user belongs to one organization only
                this.organization = this.organizations[0];
            }

            this.form.organization = this.organization;

            // - Prefill images
            const attachmentsNames = this.$utils.attachments.getAttachmentNames(this.form).sort();
            const iconFilename = this.$utils.assets.getAppIconFilename();

            this.form.screenshots = {
                image_1: null,
                image_2: null,
                image_3: null,
                image_4: null,
            };

            for (const name of attachmentsNames) {
                const imagePath = this.$utils.assets.getTemplateAssetPath(this.form._id, name);
                const url = this.$utils.url.getHomeUrl(imagePath);

                if (name === iconFilename) {
                    this.form.app_icon = [url];
                } else {
                    this.images.push(url);
                    this.form.screenshots[name] = url;
                }
            }

            // - Prefill visibility
            this.form.visibility = this.params.form.visibility || 'private';
            this.visibility = this.form.visibility;

            // - Prefill parent type
            if (this.eventId) {
                // This scenario is happening when we want to templetize a workspace
                this.form.parentType = this.parentTypes.find(p => p.value === 'workspace');
            } else {
                // This is the default scenario
                this.form.parentType = this.params.form.parentType || this.parentTypes.find(p => p.value === 'template');
            }

            // - Prefill data that depends on organization selection
            await this.loadOrgData();

            // - Prefill parent
            // Because the $watch is done before that code, we need to use $set ( https://vuejs.org/v2/guide/reactivity.html#For-Objects )
            if (this.eventId) {
                this.$set(this.form, 'parent', this.parents.find(e => e._id === this.eventId));
            } else {
                this.$set(this.form, 'parent', null);
            }

            // - Prefill category
            if (this.form.template_category) {
                this.templateCategory = this.templateCategories.find(c => c.value === this.form.template_category);
            }

            // - Prefill order
            if (this.form.visibility !== 'global') {
                this.form.template_order = null;
            }

            // - Prefill category/categories
            if (!isEmpty(this.form.description)) {
                this.form.category = get(this.form, 'description.category');
                this.form.categories = get(this.form, 'description.categories');
            }

        },

        /**
         * Loads organization data needed for the form
         */
        async loadOrgData() {
            if (!this.editing) {
                // When editing user cannot change server location nor
                // parent workspace/template
                await this.loadServersLocation();
                await this.loadParents();
            }
        },

        /**
         * Loads the available server locations starting
         * from the selected organization
         */
        async loadServersLocation() {
            if (!this.organization) {
                return;
            }

            try {
                const orgName = this.$services.org.getNameFromId(this.organization._id);
                const servers = await this.$services.server.getOrgServers(orgName);
                this.serversLocation = this.$utils.workspaces.getServersLocation(servers);
            } catch (error) {
                console.error('[TemplateForm] An error occurred while fetching org servers');
                this.$services.crashReporting.captureException(error);
                this.error = 'general.error_occurred';
            }
        },

        /**
         * Loads the possible parents for the template
         */
        async loadParents() {
            try {
                if (this.form.parentType.value === 'template') {
                    if (!this.organization) {
                        return;
                    }

                    this.templates = this.templates || await this.$services.template.getTemplatesForSelection(this.organization._id, this.$i18n.locale);
                    this.parents = this.templates;
                } else {
                    if (!this.events) {
                        const events = await this.$services.user.getUserEvents();

                        this.events = events
                            .filter(event => event.lifecycle.stage !== 'archived')
                            .sort((a, b) => this.$utils.collections.compareByKeyTypeWise('name', a, b));
                    }

                    this.parents = this.events;
                }
            } catch (error) {
                console.error('[TemplateForm] An error occurred while fetching parents');
                this.$services.crashReporting.captureException(error);
                this.error = 'general.error_occurred';
            }
        },

        /**
         * Gets the select workspace label
         *
         * @param {Object} workspace the workspace from where to get the label from
         *
         * @return {String} the standardized version of the workspace name.
         */
        workspaceLabel(workspace) {
            return this.$utils.workspaces.getWorkspaceTitle(workspace, this.$i18n.locale);
        },

        /**
         * Adds screenshots to the images pool
         *
         * @param {File[]} files the images to add
         */
        addScreenshots(files) {
            for (const file of files) {
                const replaceKey = findKey(this.form.screenshots, image => image && image.name === file.name);

                if (replaceKey) {
                    this.form.screenshots[replaceKey] = file;
                    continue;
                }

                const newKey = findKey(this.form.screenshots, image => image === null);

                this.form.screenshots[newKey] = file;
            }
        },

        /**
         * Removes a screenshots from the images pool
         *
         * @param {File} file the image to remove
         */
        removeScreenshot(file) {
            for (const [key, image] of Object.entries(this.form.screenshots)) {
                if (!image) {
                    continue;
                }

                const isOnTheServer = typeof image === 'string';
                const imageName = isOnTheServer ? image.split('/').pop() : image.name;
                if (imageName === file.name) {
                    this.form.screenshots[key] = null;

                    if (isOnTheServer) {
                        // If the image is a file it means it's not on the server yet
                        // so no need to DELETE it.
                        this.$emit('image:removed', imageName);
                    }
                }
            }
        },

        /**
         * Handler called when the user changes the visibility
         */
        visibilityChanged() {
            if (this.visibility !== 'global') {
                this.form.template_order = null;
            } else if (this.originalOrder) {
                this.form.template_order = this.originalOrder;
            }
        },

        /**
         * Cleans or remove the categories from the form payload
         */
        cleanCategories() {
            if (this.isCategoryEnabled) {
                if (this.form.hasOwnProperty('category')) {
                    this.form.category = this.canInsertMultipleCategories ? undefined : '';
                }

                if (this.form.hasOwnProperty('categories')) {
                    this.form.categories = this.canInsertMultipleCategories ? [] : undefined;
                }
            } else {
                delete this.form.category;
                delete this.form.categories;
            }
        },

        async saveSubforms() {
            if (this.$refs.activationSubform.saving) {
                return;
            }

            // triggers save from MetaForm, that we detect on activationSubform.
            await this.$refs.activationSubform.validate();

            return new Promise(resolve => {
                const unwatch = this.$watch(
                    () => this.$refs.activationSubform.saving,
                    (isSaving) => {
                        if (isSaving) {
                            return;
                        }

                        unwatch();
                        resolve();
                    }
                );
            });
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-form" },
    [
      _c("div", { staticClass: "header" }, [
        _c("h3", { staticClass: "header-label" }, [
          _vm._v(_vm._s(_vm.$t("wizards.create_template.template_data"))),
        ]),
      ]),
      _vm.error
        ? _c("div", { staticClass: "alert alert-error" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t(_vm.error)))]),
          ])
        : _c(
            "validation-observer",
            {
              ref: "form",
              staticClass: "inner-form",
              attrs: { tag: "form" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.validate.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "panels panels-b" }, [
                _c("div", { staticClass: "panel" }, [
                  _c(
                    "fieldset",
                    [
                      _vm.organizations.length > 1
                        ? _c("validation-provider", {
                            staticClass: "org",
                            attrs: {
                              rules: "required",
                              slim: true,
                              name: "organization",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-select", {
                                        attrs: {
                                          label: _vm.$t(
                                            "wizards.create_template.form.organization"
                                          ),
                                          hint: !_vm.editing
                                            ? _vm.$t(
                                                "wizards.create_template.form.organization_hint"
                                              )
                                            : "",
                                          placeholder: _vm.$t(
                                            "wizards.create_template.form.organization_placeholder"
                                          ),
                                          name: "organization",
                                          "options-label": "display_name",
                                          errors: errors,
                                          "track-by": "_id",
                                          disabled: !_vm.canChangeOrg,
                                          options: _vm.organizations,
                                        },
                                        on: { input: _vm.loadOrgData },
                                        model: {
                                          value: _vm.organization,
                                          callback: function ($$v) {
                                            _vm.organization = $$v
                                          },
                                          expression: "organization",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              137285672
                            ),
                          })
                        : _vm._e(),
                      _c("validation-provider", {
                        staticClass: "name",
                        attrs: {
                          rules: "required",
                          slim: true,
                          name: "eventname",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("base-input", {
                                  attrs: {
                                    label: _vm.$t(
                                      "wizards.create_template.form.name"
                                    ),
                                    errors: errors,
                                    placeholder: _vm.$t(
                                      "wizards.create_template.form.name_placeholder"
                                    ),
                                    type: "text",
                                    disabled: !_vm.organization,
                                    name: "eventname",
                                  },
                                  model: {
                                    value: _vm.form.eventname,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "eventname", $$v)
                                    },
                                    expression: "form.eventname",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.isCategoryEnabled
                        ? [
                            _vm.canInsertMultipleCategories
                              ? _c("validation-provider", {
                                  attrs: { slim: true, name: "categories" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("workspace-category", {
                                              attrs: {
                                                organization: _vm.organization,
                                                name: "categories",
                                                errors: errors,
                                              },
                                              model: {
                                                value: _vm.form.categories,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "categories",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.categories",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3068479057
                                  ),
                                })
                              : _c("validation-provider", {
                                  attrs: { slim: true, name: "category" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("workspace-category", {
                                              attrs: {
                                                organization: _vm.organization,
                                                name: "category",
                                                errors: errors,
                                              },
                                              model: {
                                                value: _vm.form.category,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "category",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.category",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2218325841
                                  ),
                                }),
                          ]
                        : _vm._e(),
                      _c("base-textarea", {
                        staticClass: "description",
                        attrs: {
                          label: _vm.$t(
                            "wizards.create_template.form.description"
                          ),
                          placeholder: _vm.$t(
                            "wizards.create_template.form.description_placeholder"
                          ),
                          disabled: !_vm.organization,
                          name: "description",
                        },
                        model: {
                          value: _vm.form.template_description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "template_description", $$v)
                          },
                          expression: "form.template_description",
                        },
                      }),
                      _c("html-editor", {
                        staticClass: "long-description",
                        attrs: {
                          label: _vm.$t(
                            "wizards.create_template.form.long_description"
                          ),
                          placeholder: _vm.$t(
                            "wizards.create_template.form.long_description_placeholder"
                          ),
                          disabled: !_vm.organization,
                          name: "template_long_description",
                          extras: false,
                        },
                        model: {
                          value: _vm.form.template_long_description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "template_long_description", $$v)
                          },
                          expression: "form.template_long_description",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "fieldset",
                    [
                      !_vm.editing
                        ? _c("validation-provider", {
                            staticClass: "servers_location",
                            attrs: {
                              rules: "required",
                              slim: true,
                              name: "storage",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("base-select", {
                                        attrs: {
                                          label: _vm.$t(
                                            "wizards.create_template.form.servers_location"
                                          ),
                                          placeholder: _vm.$t(
                                            "wizards.create_template.form.servers_location_placeholder"
                                          ),
                                          name: "storage",
                                          errors: errors,
                                          hint: _vm.$t(
                                            "wizards.create_template.form.servers_location_hint"
                                          ),
                                          options: _vm.serversLocation,
                                          disabled: !_vm.organization,
                                          "options-label": "label",
                                        },
                                        model: {
                                          value: _vm.form.storage,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "storage", $$v)
                                          },
                                          expression: "form.storage",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2721281363
                            ),
                          })
                        : _vm._e(),
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          slim: true,
                          name: "visibility",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("radio-buttons", {
                                  staticClass: "visibility",
                                  attrs: {
                                    label: _vm.$t(
                                      "wizards.create_template.form.visibility"
                                    ),
                                    name: "visibility",
                                    errors: errors,
                                    disabled:
                                      !_vm.organization || _vm.lockVisibility,
                                    options: _vm.visibilityOptions,
                                  },
                                  on: { input: _vm.visibilityChanged },
                                  model: {
                                    value: _vm.visibility,
                                    callback: function ($$v) {
                                      _vm.visibility = $$v
                                    },
                                    expression: "visibility",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm.editing && (_vm.userCanSetOrder || _vm.userCanSetCategory)
                    ? _c("fieldset", [
                        _c("div", { staticClass: "grouped-controls" }, [
                          _c(
                            "div",
                            { staticClass: "form-groups" },
                            [
                              _vm.userCanSetCategory
                                ? _c("base-select", {
                                    attrs: {
                                      label: _vm.$t(
                                        "wizards.create_template.form.category"
                                      ),
                                      placeholder: _vm.$t(
                                        "wizards.create_template.form.category_placeholder"
                                      ),
                                      name: "templateCategory",
                                      options: _vm.templateCategories,
                                      disabled:
                                        !_vm.organization ||
                                        !_vm.userCanSetCategory,
                                      "options-label": "name",
                                    },
                                    model: {
                                      value: _vm.templateCategory,
                                      callback: function ($$v) {
                                        _vm.templateCategory = $$v
                                      },
                                      expression: "templateCategory",
                                    },
                                  })
                                : _vm._e(),
                              _vm.userCanSetOrder
                                ? _c("validation-provider", {
                                    staticClass: "name",
                                    attrs: {
                                      rules: "numeric",
                                      slim: true,
                                      name: "order",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("base-input", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "wizards.create_template.form.order"
                                                  ),
                                                  tip: _vm.$t(
                                                    "wizards.create_template.form.order_tip"
                                                  ),
                                                  placeholder: _vm.$t(
                                                    "wizards.create_template.form.order_placeholder"
                                                  ),
                                                  errors: errors,
                                                  type: "text",
                                                  disabled:
                                                    !_vm.organization ||
                                                    !_vm.canSetOrder,
                                                  name: "order",
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.template_order,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "template_order",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.template_order",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      745463692
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  !_vm.editing
                    ? _c("fieldset", { staticClass: "blueprinting" }, [
                        _c("div", { staticClass: "grouped-controls" }, [
                          _c(
                            "div",
                            { staticClass: "form-groups" },
                            [
                              _c("validation-provider", {
                                staticClass: "parent-type",
                                attrs: {
                                  rules: "required",
                                  slim: true,
                                  name: "parentType",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("base-select", {
                                            attrs: {
                                              label: _vm.$t(
                                                "wizards.create_template.form.parent_type"
                                              ),
                                              placeholder: _vm.$t(
                                                "wizards.create_template.form.parent_type"
                                              ),
                                              name: "parentType",
                                              errors: errors,
                                              options: _vm.parentTypes,
                                              disabled: !_vm.organization,
                                              "allow-empty": false,
                                              "options-label": "name",
                                            },
                                            on: { input: _vm.loadParents },
                                            model: {
                                              value: _vm.form.parentType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "parentType",
                                                  $$v
                                                )
                                              },
                                              expression: "form.parentType",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1103206547
                                ),
                              }),
                              _c("validation-provider", {
                                staticClass: "template-parent",
                                attrs: {
                                  rules: "required",
                                  slim: true,
                                  name: "parent",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("base-select", {
                                            attrs: {
                                              label: "&nbsp;",
                                              placeholder: _vm.$t(
                                                "wizards.create_template.form.template_parent_placeholder"
                                              ),
                                              name: "parent",
                                              "custom-label":
                                                _vm.workspaceLabel,
                                              errors: errors,
                                              disabled: !_vm.organization,
                                              "allow-empty": false,
                                              options: _vm.parents,
                                            },
                                            model: {
                                              value: _vm.form.parent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "parent",
                                                  $$v
                                                )
                                              },
                                              expression: "form.parent",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  952113255
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "panel" }, [
                  _c(
                    "fieldset",
                    [
                      _c("image-picker", {
                        attrs: {
                          name: "app_icon",
                          label: _vm.$t("wizards.create_template.form.icon"),
                          hint: _vm.$t(
                            "wizards.create_template.form.icon_hint"
                          ),
                          extensions: ["png"],
                          "max-height": 512,
                          disabled: !_vm.organization || !_vm.appIconEditable,
                        },
                        model: {
                          value: _vm.form.app_icon,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "app_icon", $$v)
                          },
                          expression: "form.app_icon",
                        },
                      }),
                      _c("image-picker", {
                        attrs: {
                          label: _vm.$t(
                            "wizards.create_template.form.screenshots"
                          ),
                          hint: _vm.$t(
                            "wizards.create_template.form.screenshots_hint"
                          ),
                          name: "screenshots",
                          extensions: ["png", "jpg", "jpeg", "gif"],
                          ratio: 16 / 9,
                          multiple: true,
                          maximum: 4,
                          width: 1920,
                          height: 1080,
                          disabled: !_vm.organization,
                        },
                        on: {
                          input: _vm.addScreenshots,
                          removed: _vm.removeScreenshot,
                        },
                        model: {
                          value: _vm.images,
                          callback: function ($$v) {
                            _vm.images = $$v
                          },
                          expression: "images",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm.editing && _vm.event
                  ? _c("div", { staticClass: "panel activation-settings" }, [
                      _c(
                        "fieldset",
                        [
                          _c("nav-editor", {
                            ref: "activationSubform",
                            attrs: {
                              event: _vm.event,
                              "nav-config": _vm.navConfig,
                              user: _vm.user,
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/wizards/create-template/TemplateForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__